import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import causalService from "../services/causal.service";
import personaService from "../services/persona.service";
import reclutamientoService from "../services/reclutamiento.service";
import desvinculadoService from "../services/desvinculado.service";
import proyectoService from "../services/proyecto.service";

import { Audio, Oval } from 'react-loader-spinner';
import { useConfirm } from "material-ui-confirm";

/** Material UI */
import Button from '@mui/material/Button';
import { SnackbarProvider, useSnackbar } from 'notistack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Divider, TextField } from "@mui/material";
import { Container } from "@mui/system";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Modal from '@mui/material/Modal';
import { DataGrid } from '@mui/x-data-grid';
import MUIDataTable from 'mui-datatables';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};

const PanelRRHH = () => {
    const [casuales, setCausales] = useState([]);
    const [loading, setLoading] = useState(false);
    const confirm = useConfirm();
    const { enqueueSnackbar } = useSnackbar();
    const [arr_sel, SetArrSel] = useState([]);
    const [personas, setPersonas] = useState([]);
    const [open, setOpen] = useState(false);
    const [motivobloqueo, setMotivoBloqueo] = useState('');
    const [rut, setRut] = useState('');
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        if (!user) return navigate("/login");
        retreiveCasuales();
    }, []);

    function retreivePersonas() {
        setLoading(true);
        reclutamientoService.getAll()
            .then(resp => {
                console.log(resp.data);
                setPersonas(resp.data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }

    function retreiveCasuales() {
        console.log("Usuario Panel", user)
        console.log(loading);
        setLoading(true);
        causalService.getAll()
            .then(async resp => {
                const arr = resp.data.filter(v => v.estado !== "anulado");
                arr.sort(function (a, b) {
                    return new Date(b.createdAt) - new Date(a.createdAt)
                });
                const proyectos = await proyectoService.getAll();
                var proy_usuario = proyectos.data.filter(v => v.usuarioId === user.user.id);
                console.log("Proy Usuario", proy_usuario);
                var arr_ = [];
                for (var i in arr) {
                    const data = {
                        id: arr[i].id,
                        nombre: arr[i].persona ? arr[i].persona.perNombre1 + " " + arr[i].persona.perApPaterno + " " + arr[i].persona.perApMaterno : "",
                        descripcion: arr[i].descripcion,
                        evaluacion: arr[i].evaluacion,
                        estado_desv: arr[i].persona ? arr[i].persona.estado_desv : "",
                        estado_bloqueo: arr[i].persona ? arr[i].persona.estado_bloqueo : "",
                        rut: arr[i].persona ? arr[i].persona.Rut : "",//n.Rut
                        motivo_bloqueo: arr[i].persona ? arr[i].persona.motivo_bloqueo : "",
                        unidad: arr[i].persona ? arr[i].persona.ctoDescripcion : "",
                        fecha_ingreso: moment(arr[i].fecha_ingreso).format("DD-MM-YYYY"),
                        fecha_actual: arr[i].persona ? moment(arr[i].persona.updatedAt).format("DD-MM-YYYY") : "",
                    }
                    arr_.push(data);
                    //var n = await getPersona(arr[i].personaId);
                    /* if (arr[i].persona) {
                        if (proy_usuario.some(v => v.nombre == arr[i].persona.ctoDescripcion)) {
                            const data = {
                                id: arr[i].id,
                                nombre: arr[i].persona ? arr[i].persona.perNombre1 + " " + arr[i].persona.perApPaterno + " " + arr[i].persona.perApMaterno : "",
                                descripcion: arr[i].descripcion,
                                evaluacion: arr[i].evaluacion,
                                estado_desv: arr[i].persona ? arr[i].persona.estado_desv : "",
                                estado_bloqueo: arr[i].persona ? arr[i].persona.estado_bloqueo : "",
                                rut: arr[i].persona ? arr[i].persona.Rut : "",//n.Rut
                                motivo_bloqueo: arr[i].persona ? arr[i].persona.motivo_bloqueo : "",
                                unidad: arr[i].persona ? arr[i].persona.ctoDescripcion : "",
                                fecha_ingreso: moment(arr[i].fecha_ingreso).format("DD-MM-YYYY"),
                                fecha_actual: arr[i].persona ? moment(arr[i].persona.updatedAt).format("DD-MM-YYYY") : "",
                            }
                            arr_.push(data);
                        }
                    } */
                }
                setCausales(arr_);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }

    async function getPersona(id) {
        let persona = await personaService.getById(id);
        return persona.data;
    }

    const handleClose = () => setOpen(false);

    const bloquear = (rut) => {
        setLoading(true);
        confirm({ description: '¿Está seguro de bloquear al trabajador?', title: 'Bloquear a trabajador', confirmationText: 'Aceptar', cancellationText: 'Cancelar' })
            .then(async () => {
                setRut(rut);
                setOpen(true);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
                enqueueSnackbar("Se cancelo la acción de bloquear", { variant: "info" });
            });
    }

    const bloquearMotivo = async () => {
        setLoading(true);
        let p = await personaService.getPorRut(rut);
        console.log("Bloquer a usuario");
        reclutamientoService.getUsuarioPorRut(rut)
            .then(resp => {
                if (resp.data.length !== 0) {
                    //Si existe la persona, actualizamos el estado a bloqueado
                    console.log(resp);
                    reclutamientoService.updateTrabajador(resp.data[0].id, { disponibilidad: "Bloqueado" })
                        .then(up => {
                            console.log(up);
                            setLoading(false);
                            enqueueSnackbar("Trabajador bloqueado exitosamente !!", { variant: "success" });
                            retreiveCasuales();
                        }).catch(err => {
                            console.log(err);
                            setLoading(false);
                            enqueueSnackbar("Ocurrio un error al intentar bloquear !!", { variant: "error" });
                        });
                } else {
                    //Si no existe, lo creamos y bloqueamos
                    personaService.getPorRut(rut)
                        .then(pers => {
                            var p = pers.data[0];
                            console.log(p);
                            setLoading(false);
                            reclutamientoService.create({ rut: rut, nombre: p.perNombre1, ap_paterno: p.perApPaterno, disponibilidad: "Bloqueado" })
                                .then(resp => {
                                    console.log(resp);
                                    setLoading(false);
                                    enqueueSnackbar("Trabajador bloqueado exitosamente !!", { variant: "success" });
                                    retreiveCasuales();
                                }).catch(err => {
                                    console.error(err);
                                    setLoading(false);
                                    enqueueSnackbar("Ocurrio un error al intentar bloquear !!", { variant: "error" });
                                });
                        }).catch(err => {
                            console.error(err);
                            setLoading(false);
                            enqueueSnackbar("Ocurrio un error al intentar bloquear !!", { variant: "error" });
                        });
                }
            }).catch(err => {
                console.error(err);
                setLoading(false);
                enqueueSnackbar("Ocurrio un error al intentar bloquear !!", { variant: "error" });
            });

        let up_p = await personaService.update(p.data[0].id, { estado_bloqueo: "Bloqueado", motivo_bloqueo: motivobloqueo });
        setOpen(false);
        setLoading(false);
    }

    const columns = [
        { field: 'nombre', headerName: 'Nombre', width: 200 },
        { field: 'descripcion', headerName: 'Descripción', flex: 1 }
    ];

    //MUI Table

    const options = {
        filterType: 'multiselect',
        responsive: 'vertical',
        onRowSelectionChange: (rowsSelectedData, allRows, rowsSelected) => {
            SetArrSel(rowsSelected);
            //console.log(rowsSelectedData, allRows, rowsSelected);
        },

    };

    const columns2 = [
        { name: 'rut', label: 'Rut' },
        { name: 'nombre', label: 'Nombre' },
        { name: 'descripcion', label: 'Causal' },
        { name: 'evaluacion', label: 'Evaluación' },
        { name: 'estado_desv', label: 'Estado Desvinculación' },
        { name: 'unidad', label: 'Unidad de Negocio' },
        { name: 'fecha_ingreso', label: 'Fecha Ingreso de Solicitud' },
        { name: 'fecha_actual', label: 'Fecha Actual de Solicitud' },
    ];

    const bloqueMasivo = () => {
        for (var i in arr_sel) {
            var c = casuales[arr_sel[i]];
            console.log(c);
        }
    }

    return (
        loading ? (
            <div>
                <div className="d-flex justify-content-center">
                    <Oval
                        heigth="100"
                        width="100"
                        color='blue'
                        ariaLabel='loading'
                    />
                </div>
                <p className="text-center">Cargando ...</p>
            </div>
        ) : (
            <Container maxWidth="xl">
                <Box style={{
                    margin: 3,
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Typography variant="h6" m={2}>
                        Trabajadores
                    </Typography>
                    <MUIDataTable
                        title={"Status Proceso de Desvinculación"}
                        data={casuales}
                        columns={columns2}
                        options={options}
                    />
                    {/* <Button onClick={() => bloqueMasivo()}>Bloqueo Masivo</Button> */}
                    <Divider></Divider>
                    {/* <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Nombre</TableCell>
                                    <TableCell>Causal</TableCell>
                                    <TableCell>Evaluación</TableCell>
                                    <TableCell>Editar</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {casuales.map((item) => {
                                    return (
                                        <TableRow
                                            key={item.id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                {item.nombre}
                                            </TableCell>
                                            <TableCell align="left">{item.descripcion}</TableCell>
                                            <TableCell align="left">{item.evaluacion}</TableCell>
                                            <TableCell align="left"><Button variant="contained" onClick={() => bloquear(item.rut)}>Bloquear</Button></TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer> */}
                </Box>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                >
                    <Box sx={{ ...style, width: 400 }}>
                        <h2 id="parent-modal-title">Motivo del Bloqueo</h2>
                        <TextField
                            label="Motivo del bloqueo"
                            name="motivo_bloqueo"
                            id="motivo_bloqueo"
                            fullWidth
                            multiline
                            rows={4}
                            onChange={(e) => setMotivoBloqueo(e.target.value)}
                        />
                        <Box sx={{ alignItems: "end", justifyContent: "end", display: "flex", margin: 2 }}>
                            <Button variant="contained" onClick={bloquearMotivo}>Bloquear</Button>
                        </Box>
                    </Box>
                </Modal>
            </Container>
        )
    )
}

export default function PanelRRHHStack() {
    return (
        <SnackbarProvider maxSnack={3}>
            <PanelRRHH />
        </SnackbarProvider>
    );
}